export default "__VITE_ASSET__DvGOtgC6__"